import useAffiliateStore from './store'
import AffiliateMessages from './localization'

export default {
  useAffiliateStore,
  localization: AffiliateMessages,
}
